var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"media"},[_c('StackingView',{ref:"view",attrs:{"link":{ id: _vm.$route.params.id, type: 'Entry' },"sysType":"entry"},on:{"close":function($event){return _vm.$router.push(_vm.base + '/entries')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }